// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetDistrictsPayload} from '../actions/setDistricts'

export function setDistrictsReducer(state: MapState, action: Action<SetDistrictsPayload>): MapState {

  return {
    ...state,
    districts: action.payload.districts,
  }
}
